module.exports = __webpack_public_path__ + "img/34800.061a20e6.jpg";